import { render, staticRenderFns } from "./PartsEnquiry.vue?vue&type=template&id=21857044"
import script from "./PartsEnquiry.vue?vue&type=script&lang=js"
export * from "./PartsEnquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports